import React from "react";
import Layout from "components/structure/Layout";
import './ImportHierarchy.css'; // Ensure you have appropriate styles
import ImportList from "../Common/ImportList";

const ImportHierarchy = () => {
  return (
    <Layout title={"Import Hierarchy"}>
      <ImportList entityName="ImportHierarchy"  displayName="Import Hierarchy"/>
    </Layout>
  );
};

export default ImportHierarchy;
